"use client";

import { useRouter } from "next/navigation";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  useToast,
} from "@/components/ui";
import { LogOut, X } from "lucide-react";
import { logout } from "@/services";
import { useAuthContext } from "@/components/providers/auth-provider";

export function AppHeader() {
  const router = useRouter();
  const { username, email, userRole } = useAuthContext();
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      const state = localStorage.getItem("oauth_state") || "";

      logout({ state }).then(() => {
        document.cookie = "access_token=; id_token=; path=/; max-age=0";
        localStorage.clear();
        router.push("/logout/callback");
        toast({
          variant: "success",
          description: "Logout successful",
          duration: 2000,
        });
      });
    } catch (error) {
      console.error(error);
      toast({
        variant: "error",
        description: "Failed to logout",
        duration: 2000,
      });
    }
  };

  return (
    <header className="flex items-center justify-between px-10 pt-7">
      <div className="w-full flex items-center justify-end gap-4 md:gap-8">
        <div className="w-fit">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className="w-8 h-8 flex items-center justify-center text-white bg-[linear-gradient(180deg,#00A4D5_0%,#0168ED_100%)] rounded-full p-1.5 cursor-pointer">
                <div className="text-sm font-medium text-white uppercase">
                  {username?.slice(0, 2)?.toUpperCase()}
                </div>
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent side="bottom" align="end" className="w-56 p-4 pt-6">
              <div className="relative flex flex-col gap-4">
                <div className="flex flex-col items-center gap-2.5">
                  <div className="w-20 h-20 flex items-center justify-center bg-[linear-gradient(180deg,#00A4D5_0%,#0168ED_100%)] rounded-full p-1.5">
                    <div className="text-2xl font-medium text-white uppercase">
                      {username?.slice(0, 2)?.toUpperCase()}
                    </div>
                  </div>
                  <div className="space-y-1">
                    {username && (
                      <p className="text-sm font-medium leading-[1.4] text-[#00152C] text-center">
                        Hi, {username}!
                      </p>
                    )}
                    {email && (
                      <p className="text-xs leading-[1.4] text-[#000000] text-center">{email}</p>
                    )}
                    {userRole && (
                      <p className="text-xs leading-[1.4] text-blue-500 text-center font-semibold">
                        {userRole}
                      </p>
                    )}
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="lg"
                  className="w-full justify-start text-[#00152C]"
                  onClick={handleLogout}
                >
                  <LogOut /> Sign out
                </Button>
                <DropdownMenuItem className="absolute -top-5 -right-3 p-1.5 rounded-full">
                  <X />
                </DropdownMenuItem>
              </div>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
